import i18n from 'src/lib/i18n/i18n';
import { WebPaymentMethod } from '../iap.types';
import { getAvailablePaymentMethods } from '../iap.utils';
import { SecureShield, Info } from './Icons';
import { PaymentMethodButton } from './PaymentMethodButton';
import { PaymentMethodBigButton } from './PaymentMethodBigButton';
import { user } from 'src/StateObserver';

/**
 * Payment methods list.
 * @param
 * @returns
 */
export function PaymentMethodsList({
  setSelectedPaymentMethod,
  onInfoClick,
}: {
  setSelectedPaymentMethod: (method: WebPaymentMethod) => void;
  onInfoClick?: () => void;
}) {
  const { list } = getAvailablePaymentMethods();

  const lastUsedPaymentMethod =
    (user().lastPaymentMethod as WebPaymentMethod) ?? list[0];

  return (
    <>
      <div class="secure" onClick={onInfoClick}>
        <SecureShield />
        <div id="paymentSecure">{i18n('openWebPay.select')}</div>
        {onInfoClick && <Info />}
      </div>
      <div class="paymentMethods" id="paymentMethods">
        {list.map((method) => {
          return method === 'komoju_paypay' ? (
            <PaymentMethodBigButton
              paymentMethod={method}
              key={method}
              onClick={(e) => {
                e.preventDefault();
                setSelectedPaymentMethod(method);
              }}
            />
          ) : (
            <PaymentMethodButton
              paymentMethod={method}
              key={method}
              onClick={(e) => {
                e.preventDefault();
                setSelectedPaymentMethod(method);
              }}
            />
          );
        })}
      </div>
    </>
  );
}
